import { Link } from '@trashlab/sitesapp/src/organizations/redebins/components/shared/link';
import { OrderButtons } from '@trashlab/sitesapp/src/organizations/redebins/template/components/shared/order-buttons';

export const ProhibitedItemsHeroSection = () => {
  return (
    <section className="relative bg-gray-900 text-white py-20 md:py-32">
      {/* Background image overlay - same as homepage */}
      <div className="absolute inset-0 z-0">
        <div
          className="absolute inset-0 bg-cover bg-center"
          style={{
            backgroundImage: "url('/redebins/images/hero-background.jpg')",
          }}
        />
        <div className="absolute inset-0 bg-black/50" />
      </div>

      <div className="container mx-auto px-4 relative z-10">
        <div className="max-w-4xl mx-auto text-center">
          <h1 className="text-4xl md:text-6xl font-bold mb-4 italic">
            What Can You Throw in a RED-E-BIN?
          </h1>
          <p className="text-lg md:text-xl text-white mb-8 max-w-2xl mx-auto" style={{ textShadow: '0 1px 3px rgba(0,0,0,0.6)' }}>
            Most{' '}
            <Link href="/residential" className="underline hover:text-white">residential</Link>
            {' '}and{' '}
            <Link href="/commercial" className="underline hover:text-white">commercial</Link>
            {' '}cleanouts &amp; remodeling projects are good to go.
          </p>
          <p className="text-base text-white mb-10" style={{ textShadow: '0 1px 3px rgba(0,0,0,0.6)' }}>
            Have a mix of items or not sure what fits?{' '}
            <a href="tel:9529312577" className="underline hover:text-white">Call</a>,{' '}
            <a href="sms:9529312577" className="underline hover:text-white">text</a>{' '}
            or chat with us.
          </p>

          {/* Order Buttons */}
          <OrderButtons />
        </div>
      </div>
    </section>
  );
};
